import { render, staticRenderFns } from "./BackofficeAuditoria.vue?vue&type=template&id=749bc5c1"
import script from "./BackofficeAuditoria.vue?vue&type=script&lang=ts"
export * from "./BackofficeAuditoria.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports